import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/** Gemeinsamer Query-Client (auch außerhalb von React für Invalidierungen aus Gateway-Ereignissen). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

/** Query-Schlüssel an einer Stelle, damit Invalidierungen zu den Abfragen passen. */
export const qk = {
  authConfig: ['auth-config'] as const,
  invite: (code: string) => ['invite', code] as const,
  invites: (serverId: string) => ['invites', serverId] as const,
  bans: (serverId: string) => ['bans', serverId] as const,
  members: (serverId: string, q = '') => ['members', serverId, q] as const,
  pins: (channelId: string) => ['pins', channelId] as const,
  threads: (channelId: string, archived = false, tagId = '') => ['threads', channelId, archived, tagId] as const,
  threadMembers: (threadId: string) => ['thread-members', threadId] as const,
  profile: (userId: string, serverId = '') => ['profile', userId, serverId] as const,
  sessions: ['sessions'] as const,
  themes: ['themes'] as const,
  notifications: ['notifications'] as const,
  mentions: ['mentions'] as const,
  reactors: (messageId: string, key: string) => ['reactors', messageId, key] as const,
  sounds: (serverId: string) => ['sounds', serverId] as const,
};
